<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <!-- Tabs -->
    <CCardHeader
      style="background-color:#486ba7"
      class="text-white border-0 py-2 pt-3 font-weight-bold d-flex align-items-center"
    >
      <h5>
        <b>W-01 TAX REVIEW DAN PENYUSUNAN</b>
      </h5>
      <CButton
        color="info"
        style="float:right;margin-right:10px;"
        class="btn-md p-2 ml-auto"
      >Pindahkan ke E-Certificate</CButton>
      <CButton color="danger" style="float:right;margin-right:10px" class="btn-md">Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
      <router-link to="/pelatihan/workshop/tambah">
        <CButton color="success" style="float:right;margin-right:10px" class="btn-md">Tambah</CButton>
      </router-link>
    </CCardHeader>
    <CCardHeader class="bg-primary text-white">
      <b>Absensi Peserta</b>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>
                    <input type="checkbox" name id="pilihSemua" />
                  </th>
                  <th>No. Anggota</th>
                  <th>Nama Peserta</th>
                  <th>Email</th>
                  <th>KAP</th>
                  <th>Level</th>
                  <th>Absen Pagi</th>
                  <th>Absen Sore</th>
                  <th>Persyaratan Administrasi</th>
                  <th class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>092343298</td>
                  <td>Ilham Majid</td>
                  <td>ilhammajid@gmail.com</td>
                  <td>Aryana Amir Jusuf Mawar dan saptono</td>
                  <td>Dasar</td>
                  <td>08:00</td>
                  <td>16:00</td>
                  <td>
                    <button class="btn btn-sm btn-success">Terverifikasi</button>
                  </td>
                  <td class="text-center d-flex align-items-center">
                    <CButton color="info" class="btn-sm mr-1" square>
                      <font-awesome-icon icon="edit"/>
                    </CButton>&nbsp;&nbsp;
                    <CButton color="danger" class="btn-sm" square >
                      <font-awesome-icon icon="coins" />
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal detail -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <div class="d-block">
                <h5>Kode</h5>
                <p class="ml-3 text-muted">W-01</p>
              </div>
              <div class="d-block">
                <h5>Nama Pelatihan</h5>
                <p class="ml-3 text-muted">Tax Review Dan Pelatihan Akuntan</p>
              </div>
              <div class="d-block">
                <h5>Pengelola</h5>
                <p class="ml-3 text-muted">IAPI</p>
              </div>
              <div class="d-block">
                <h5>Tanggal Pelaksanaan</h5>
                <p class="ml-3 text-muted">26 - 29 Maret 2020</p>
              </div>
              <div class="d-block">
                <h5>Kota/Kab</h5>
                <p class="ml-3 text-muted">Jakarta</p>
              </div>
              <div class="d-block">
                <h5>ALamat</h5>
                <p class="ml-3 text-muted">IAPI Pusat Korwil Jakarta</p>
              </div>
              <div class="d-block">
                <h5>Biaya</h5>
                <div class="row ml-3">
                  <div class="col-12">
                    <p class="mb-0">Anggota AP : Rp. 500.000,</p>
                    <p class="mb-0 text-muted">Anggota Non AP : Rp. 700.000</p>
                    <p class="mb-0 text-muted">Anggota Umum Rp. 800.000</p>
                  </div>
                </div>
              </div>
              <div class="d-block mt-3">
                <h5>Perolehan SKP</h5>
                <div class="col-12">
                  <p class="font-weight-bold mb-0">SKP IAPI</p>
                  <p class="ml-3 mb-0 text-muted">Terstruktur : 30</p>
                  <p class="ml-3 mb-0 text-muted">Tidak Terstruktur : 15</p>
                  <p class="ml-3 mb-0 text-muted">Assesment : 20</p>
                </div>
                <div class="col-12 mt-2">
                  <p class="font-weight-bold mb-0">SKP Non IAPI</p>
                  <p class="ml-3 mb-0 text-muted">Terstruktur : 30</p>
                  <p class="ml-3 mb-0 text-muted">Tidak Terstruktur : 15</p>
                </div>
              </div>
              <div class="d-block mt-3">
                <h5>Jumlah Kursi</h5>
                <p class="ml-3 text-muted">100</p>
              </div>
              <div class="d-block mt-3">
                <h5>Sisa Kursi</h5>
                <p class="ml-3 text-muted">23</p>
              </div>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
const items = [
  {
    no: "1",
    _checkbox: 1,
    no_anggota: "AGT-1",
    nm_peserta: "Fachrudin Satya Al-Farobi Anwar",
    kap: "Aryanto Amir",
    level: "Dasar",
    absen_pagi: "08:00",
    absen_sore: "16:00",
    _Persyaratan_Administrasi: 1
  },
  {
    no: "2",
    _checkbox: 2,
    no_anggota: "AGT-2",
    nm_peserta: "Fachrudin Satya Al-Farobi Anwar",
    kap: "Aryanto Amir",
    level: "Dasar",
    absen_pagi: "08:00",
    absen_sore: "16:00",
    _Persyaratan_Administrasi: 0
  },
  {
    no: "3",
    _checkbox: 3,
    no_anggota: "AGT-3",
    nm_peserta: "Fachrudin Satya Al-Farobi Anwar",
    kap: "Aryanto Amir",
    level: "Dasar",
    absen_pagi: "08:00",
    absen_sore: "16:00",
    _Persyaratan_Administrasi: 1
  },
  {
    no: "4",
    _checkbox: 4,
    no_anggota: "AGT-4",
    nm_peserta: "Fachrudin Satya Al-Farobi Anwar",
    kap: "Aryanto Amir",
    level: "Dasar",
    absen_pagi: "08:00",
    absen_sore: "16:00",
    _Persyaratan_Administrasi: 0
  },
  {
    no: "5",
    _checkbox: 5,
    no_anggota: "AGT-5",
    nm_peserta: "Fachrudin Satya Al-Farobi Anwar",
    kap: "Aryanto Amir",
    level: "Dasar",
    absen_pagi: "08:00",
    absen_sore: "16:00",
    _Persyaratan_Administrasi: 1
  }
];

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false
  },
  {
    key: "_checkbox",
    _type: '<input type="checkbox" class="editor-active">',
    //   type: "#checkbox"

    //   type: _checkbox,
    sorter: false,
    filter: false
  },
  //   '_checkbox',
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "nm_peserta",
    label: "Nama Peserta",
    sorter: true,
    filter: false
  },
  {
    key: "kap",
    label: "KAP",
    sorter: true,
    filter: false
  },
  {
    key: "level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "absen_pagi",
    label: "Absen Pagi",
    sorter: false,
    filter: false
  },
  {
    key: "absen_sore",
    label: "Absen Sore",
    sorter: false,
    filter: false
  },
  {
    key: "_Persyaratan_Administrasi",
    text: "",
    sorter: false,
    filter: false
  },
  //   {
  //     key: "_Persyaratan_Administrasi",
  //     sorter: false,
  //     filter: false
  //   },
  // "_Persyaratan_Administrasi",
  {
    key: "aksi",
    _style: "width:15%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Workshop",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),      
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    $("#pilihSemua").click(function() {
      $("input:checkbox")
        .not(this)
        .prop("checked", this.checked);
    });
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>